import { getLocalStorage } from "../../../helpers/localStorage/localStorage";
import { LOCAL_STORAGE_SUBSTITUTED_USER_FLAG } from "./constants";

export const getSubstitutedUserFlag = (): boolean =>
  getLocalStorage(
    LOCAL_STORAGE_SUBSTITUTED_USER_FLAG,
    (x): x is boolean => typeof x === "boolean",
    false
  );
